import { frameForHeading, headingKindForSprite } from './headings.js';
import type { Rotation } from './projection.js';

/** Directed frame for a sprite whose atlas entry carries `rotations` frames. */
export const rotationFrameIndex = (rotations: number, heading: number, cameraRotation: Rotation): number =>
  frameForHeading(heading, cameraRotation, 'directed', rotations);

/** Atlas frame for sprite `id`: track sprites are rail-canonicalised, the frame count comes from the atlas. */
export const spriteFrameIndex = (id: string, rotations: number, heading: number, cameraRotation: Rotation): number =>
  frameForHeading(heading, cameraRotation, headingKindForSprite(id), rotations);
